import React from "react";
import { Container, Nav, Navbar } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import { useTranslation } from 'react-i18next';
import "./SubNavigation.css";
import SubNavigationManager from "./SubNavigationManager";
import SubNavigationSettings from "./SubNavigationSettings";
import SubNavigationLocationManager from "./SubNavigationLocationManager";
import { useNavigate } from "react-router-dom";

function SubNavigation(props) {
  const { t } = useTranslation();
  const history = useNavigate();
  
  return (
    <>
      { (props.currentLocation === '/drivingsummary') ? <SubNavigationManager /> : 
        (props.currentLocation === '/accesslog') ? <SubNavigationLocationManager /> : 
        (props.currentLocation === '/settings') ? <SubNavigationSettings /> : "" }
    </>
  );
}

export default SubNavigation;